module.exports = __webpack_public_path__ + "img/4.ff4832d6.jpeg";